// @flow

import React from 'react';
import { RadioGroup } from 'operation-diameter';
import BorderedBoxRadio from 'shared/components/BorderedBoxRadio';

import styles from './EnhancedRadioGroup.module.css';
import cx from 'classnames';

type Props = {
  legend: string,
  isLegendVisible?: boolean,
  error?: string,
  radios: Array,
  name: string,
  onChange: Function,
  selectedValue?: number | string | boolean,
  additionalClassnames?: string,
  dataTestId?: string
};

const EnhancedRadioGroup = ({
  legend,
  isLegendVisible = true,
  error = false,
  radios,
  name,
  onChange,
  selectedValue,
  additionalClassnames,
  dataTestId
}: Props) => {
  const generateId = (value) =>
    `${name}-${value.toString().replace(/[^a-zA-Z0-9]+/g, '-')}`;

  return (
    <RadioGroup
      legend={legend}
      isLegendVisible={isLegendVisible}
      additionalClassnames={cx(
        styles.radioGroup,
        additionalClassnames && additionalClassnames
      )}
      error={error && 'Please select an option.'}
      data-testid={dataTestId}>
      {radios.map(({ value, label }) => (
        <BorderedBoxRadio
          id={generateId(value)}
          key={generateId(value)}
          name={name}
          label={label}
          value={value}
          onChange={onChange}
          defaultChecked={selectedValue === value}
          isError={error}
        />
      ))}
    </RadioGroup>
  );
};

export default EnhancedRadioGroup;
